import { Buffer } from 'buffer';
import crypto from 'crypto';

export class SignatureException extends Error {
  constructor(message) {
    super(message);
    this.name = 'SignatureException';
  }
}

export function getHMacSHA256(data, key) {
  try {
    const hmac = crypto.createHmac('sha256', key);
    hmac.update(data);
    return hmac.digest('base64');
  } catch (error) {
    console.error('Failed to generate HMAC:', error);
    throw new SignatureException('Failed to generate HMAC');
  }
}
